export default function ArrayValues({ label, values }) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      {values.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {values.map((value, index) => (
            <span key={index} className="inline-block bg-blue-50 text-blue-700 text-xs font-medium mr-2 mb-1 px-3 py-1 rounded-full">
              {value}
            </span>
          ))}
        </div>
      ) : (
        <span className="text-gray-400 italic text-sm">无</span>
      )}
    </div>
  );
}
